// material-ui
import { alpha, Theme } from '@mui/material/styles';

// types
import { CustomShadowProps } from '@assetron/common/types/theme';

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS ||============================== //

export default function CustomShadows(theme: Theme): CustomShadowProps {
  return {
    // z1: `0px 2px 8px rgba(0, 0, 0, 0.15)`,
    button: `0 2px #0000000b`,
    text: `0 -1px 0 rgb(0 0 0 / 12%)`,
    z1: `0px 1px 4px ${alpha(theme.palette.common.black, 0.08)}`,
    primary: `0 0 0 2px ${alpha(theme.palette.primary[600], 0.2)}`,
    secondary: `0 0 0 2px ${alpha(theme.palette.secondary.main, 0.2)}`,
    error: `0 0 0 2px ${alpha(theme.palette.error[600], 0.2)}`,
    warning: `0 0 0 2px ${alpha(theme.palette.warning.main, 0.2)}`,
    info: `0 0 0 2px ${alpha(theme.palette.info.main, 0.2)}`,
    success: `0 0 0 2px ${alpha(theme.palette.success.main, 0.2)}`,
    grey: `0 0 0 2px ${alpha(theme.palette.grey[400], 0.2)}`,
    primaryButton: `0 14px 12px ${alpha(theme.palette.primary.main, 0.2)}`,
    secondaryButton: `0 14px 12px ${alpha(theme.palette.secondary.main, 0.2)}`,
    errorButton: `0 14px 12px ${alpha(theme.palette.error.main, 0.2)}`,
    warningButton: `0 14px 12px ${alpha(theme.palette.warning.main, 0.2)}`,
    infoButton: `0 14px 12px ${alpha(theme.palette.info.main, 0.2)}`,
    successButton: `0 14px 12px ${alpha(theme.palette.success.main, 0.2)}`,
    greyButton: `0 14px 12px ${alpha(theme.palette.grey[400], 0.2)}`,
    buttonShadowXS: `0px 1px 2px 0px ${alpha('#0C2146', 0.05)}`,
    buttonShadowSM: `0px 1px 2px 0px ${alpha('#0C2146', 0.06)}, 0px 1px 3px 0px ${alpha('#0C2146', 0.1)}`,
    buttonShadowMD: `0px 2px 4px -2px ${alpha('#0C2146', 0.06)}, 0px 4px 8px -2px ${alpha('#0C2146', 0.1)}`,
    buttonShadowLG: `0px 4px 6px -2px ${alpha('#0C2146', 0.03)}, 0px 12px 16px -4px ${alpha('#0C2146', 0.08)}`,
    buttonShadowXL: `0px 8px 8px -4px ${alpha('#0C2146', 0.03)}, 0px 20px 24px -4px ${alpha('#0C2146', 0.08)}`,
    buttonShadow2XL: `0px 24px 48px -12px ${alpha('#0C2146', 0.18)}`,
    buttonShadow3XL: `0px 32px 64px -12px ${alpha('#0C2146', 0.14)}`,
    dropShadowXXS: `0px 0.5px 1px 0px ${alpha('#0C2146', 0.05)}`,
    dropShadowXS: `0px 1px 2px 0px ${alpha('#0C2146', 0.05)}`,
    dropShadowSM: `0px 1px 2px 0px ${alpha('#0C2146', 0.06)}, 0px 1px 3px 0px ${alpha('#0C2146', 0.1)}`,
    dropShadowXL: `0px 20px 24px -4px ${alpha('#0C2146', 0.08)}, 0px 8px 8px -4px ${alpha('#0C2146', 0.04)}`,
    dropShadowLG: `0px 4px 6px -2px ${alpha('#0C2146', 0.04)}, 0px 12px 16px -4px ${alpha('#0C2146', 0.08)}`,
    dropShadowMD: `0px 2px 4px -2px ${alpha('#0C2146', 0.04)}, 0px 4px 8px -2px ${alpha('#0C2146', 0.08)}`,
    dropShadow2XL: `0px 24px 48px -12px ${alpha('#0C2146', 0.18)}`,
    dropdownShadow: `0 0 24px -4px ${alpha('#0C2146', 0.16)}, 0 0 8px -4px ${alpha('#0C2146', 0.08)}`,
  };
}
